<template>
   <PageFull header="Все кошельки" type="white" :fullwidth="true" :nopadding="false">
        <template v-slot:body>
            <div class="w-full p-0">    
                <WalletList v-if='wallets' 
                    :wallets="wallets" :loading="loading" :total="totalRecords"
                    @filter="setFilter" @lazyParams="setParams" :defaultParams="lazyParams"/>
                <Skeleton height="2rem" v-else />
            </div>
        </template>
    </PageFull>
</template>

<script>
import Connect from '@/assets/js/connect.js'
import Helper from '@/assets/js/helper.js'
import PageFull from '@/components/public/page.vue'
import WalletList from '@/components/admin/wallet/list.vue'

export default {
    data() {
        return {
            wallets: null,
            loading: false,
            totalRecords: null,
            lazyParams: {
                first: 0,
                rows: 20,
                sort: null,
                sortField: null,
                sortOrder: null,
                filters: {},
            },
            filters: {
                _id: {value: '', matchMode: 'contains'},
                is_blockchain: {value: null, matchMode: 'contains'},
                user_id: {value: '', matchMode: 'contains'},
                type: {value: '', matchMode: 'contains'},
                ext_type: {value: '', matchMode: 'contains'},
                created_at: {value: '', matchMode: 'contains'},
            },
        }
    },
    components: {
        PageFull,
        WalletList
    },
    methods: {
        setFilter(filters) {
            this.lazyParams.filters = filters
            this.loadLazyData();
        },
        setParams(params) {
            this.lazyParams = params
            this.loadLazyData()
        },
        async loadLazyData() {
            this.loading = true
            window.scrollTo({ top: 0, behavior: 'smooth' }) //скролл вверх

            const limit = (this.lazyParams.rows) ? this.lazyParams.rows : 50
            const skip = (this.lazyParams.first) ? this.lazyParams.first : 0
            const filter = (this.lazyParams.filters) ? this.lazyParams.filters : {}
            let sort = (this.lazyParams.sort) ? this.lazyParams.sort : null

            const wallets = await this.connect.GetAdminWalletList(limit, skip, filter, sort).then(res => res)
            if (wallets.result) {
                this.wallets = wallets.data.list
                this.totalRecords = wallets.data.total
            }
            this.loading = false
        },
    },
    async beforeCreate() {
        this.connect = new Connect()
        this.helper = new Helper()
    },
    mounted(){
        this.lazyParams.filters = this.filters
        
        // получим параметры из url
        const query = (this.$route.query) ? this.$route.query : {}
        if(query && query.type) this.filters.ext_type = {value: query.type, matchMode: 'contains'}
        if(query && query.user_id) this.filters.user_id = {value: query.user_id, matchMode: 'contains'}

        this.loadLazyData()
    }
}
</script>